import CurrencyLogo from 'components/CurrencyLogo'
import Tag from 'components/Tag'
import React, { useState } from 'react'

import { EntriesStyled, PoolCardStyled } from './styled'
import { SkeletonText } from 'components/Skeleton'
import { useToken } from 'hooks/Tokens'
import { LHYPE_ACCOUNTANT_ADDRESS, LHYPE_ADDRESS } from '@hyperswap/addresses'
import { Currency } from '@uniswap/sdk-core'
import LHYPELogo from '../../../assets/lhype-logo.svg'
import { ReactComponent as ImperatorLogoWhite } from '../../../assets/imperator-logo-full-white.svg'
import { roundToDecimalPlace } from 'utils/data'
import { EARN_LHYPE_IS_DISABLED } from 'constants/config'
import { getContract } from 'utils'
import { abi as LHYPE_ABI } from '../../../abis/looped/LHYPE.json'
import { abi as LHYPE_ACCOUNTANT_ABI } from '../../../abis/looped/AccountantWithRateProviders.json'

import { useActiveWeb3React } from 'hooks'
import { formatUnits } from 'ethers/lib/utils'

const IS_DISABLED = EARN_LHYPE_IS_DISABLED

const LHYPEPoolCard: React.FC = () => {
  const { library, account } = useActiveWeb3React()
  const lHYPEToken = useToken(LHYPE_ADDRESS)
  const [data, setData] = useState<any>({
    apr: null,
    tvl: null,
  })
  const [loading, setLoading] = useState<boolean>(true)

  return null
  React.useEffect(() => {
    async function fetchData() {
      if (library && account) {
        try {
          const lHYPEContract = getContract(LHYPE_ADDRESS, LHYPE_ABI, library, account)
          const accountantContract = getContract(LHYPE_ACCOUNTANT_ADDRESS, LHYPE_ACCOUNTANT_ABI, library, account)

          /* const hypePriceResponse = await axios.get(
            'https://api.coingecko.com/api/v3/coins/hyperliquid/market_chart?vs_currency=usd&days=0'
          ) */
          const totalSupplyRaw = await lHYPEContract.totalSupply()
          const totalSupply = formatUnits(totalSupplyRaw, 18)

          const rateRaw = await accountantContract.getRate()
          const rate = formatUnits(rateRaw, 18)

          const tvl = parseFloat(totalSupply) * parseFloat(rate)

          setData({
            apr: null,
            tvl: tvl || null,
          })

          setLoading(false)
        } catch (error) {
          console.error(error)
          setLoading(false)
        }
      }
    }

    if (loading) {
      fetchData()
    }
  }, [account, library, loading])

  return (
    <PoolCardStyled role="button" to={`/stake/LHYPE`} disabled={IS_DISABLED}>
      <div className="poolCard__tag">
        {IS_DISABLED ? <Tag variant={1}>Inactive</Tag> : <Tag variant={2}>Active</Tag>}
      </div>

      <div className="poolCard__header">
        <CurrencyLogo currency={lHYPEToken as Currency} size={'42px'} />
        <h2>Earn LHYPE</h2>
      </div>
      <div className="poolCard__subheader">
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          <span>Powered by</span>{' '}
          <img src={LHYPELogo} alt="lhype logo" style={{ width: '16px', borderRadius: '100px' }} />
          <span>loopedHYPE &</span>
          <ImperatorLogoWhite />
          <span>Imperator</span>
        </div>
      </div>
      <EntriesStyled>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>APY</span>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>TVL</span>
        <span style={{ height: '16px', fontSize: '12px' }}>
          Target APY: ≈10%
          {/*  {loading || !data?.apr || IS_DISABLED ? (
            <SkeletonText width="50%" height="100%" />
          ) : (
            `${roundToDecimalPlace(data?.apr, '3')}%`
          )} */}
        </span>
        <span style={{ height: '16px', fontSize: '12px' }}>
          {loading || !data?.tvl || IS_DISABLED ? (
            <SkeletonText width="80%" height="100%" />
          ) : (
            `${roundToDecimalPlace(data?.tvl, '3')} HYPE`
          )}
        </span>
      </EntriesStyled>
    </PoolCardStyled>
  )
}
export default LHYPEPoolCard
